var React = require('react');

function Close12x12 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Color=Black, State=Close, Size=12x12"},React.createElement("path",{"id":"Vector","d":"M9.535 2.464L6 6m0 0L2.464 9.535M6 6l3.536 3.535M6 6L2.464 2.464","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round"})));
}

Close12x12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Close12x12;

Close12x12.default = Close12x12;
